import { Checkbox, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  isDisabled: { opacity: 0.5 },
  isEnabled: { fontWeight: 'bold' },
  checkboxWrapper: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    zIndex: 2
  },
  img: {
    maxHeight: 48,
    maxWidth: 90,
    width: '100%',
    objectFit: 'contain',
    display: 'block',
    margin: '0 auto'
  },
  checkboxCustom: {
    color: '#337dc7 !important'
  }
}));

const MetricPanelCard = ({
  id,
  img,
  title,
  disabled,
  checked,
  getValue
}) => {
  const classes = useStyles();

  return (
    <div
      className="card"
      style={checked ? { backgroundColor: '#eaf2f9' } : {}}
    >
      <div className={classes.checkboxWrapper}>
        <Checkbox
          checked={checked}
          disabled={disabled}
          id={id}
          onChange={e => getValue && getValue(e.target.checked)}
          classes={{ root: classes.checkboxCustom }}
        />
      </div>
      {img ? (
        <img src={img} className={classes.img} alt={title} />
      ) : null}
      <Typography
        gutterBottom
        variant="h6"
        component="h6"
        className={disabled ? classes.isDisabled : classes.isEnabled}
      >
        {title}
      </Typography>
    </div>
  );
};

export default MetricPanelCard;
